module.exports = __webpack_public_path__ + "static/red-hat-linux-feef9126413425b11c55c1048033ae3d.png";